import { checkPermission, hasAdminAccess, permissionType } from "../common/Functions";
import { FINANCE_MANAGEMENT_BASE_PATH } from "./financeManagementTabs";

export const EXPENSE_MANAGEMENT_TABS = [
  {
    key: "list",
    label: "Expenses",
    permission: permissionType.FINANCE_EXPENSES,
    permissionKey: "read",
  },
  {
    key: "office",
    label: "Office Expenses",
    permission: permissionType.FINANCE_EXPENSES,
    permissionKey: "office_read",
  },
  // { key: "documents", label: "Upload Document", permission: permissionType.FINANCE_DOCUMENTS },
];

export const getExpenseManagementTabPath = (sectionKey = "list") => {
  if (sectionKey === "documents") {
    return `${FINANCE_MANAGEMENT_BASE_PATH}/expenses/documents`;
  }
  if (sectionKey === "office") {
    return `${FINANCE_MANAGEMENT_BASE_PATH}/expenses/office`;
  }
  return `${FINANCE_MANAGEMENT_BASE_PATH}/expenses`;
};

export const getExpenseSectionFromPath = (pathname) => {
  const match = String(pathname || "").match(/\/finance-management\/expenses\/([^/]+)/);
  const section = match?.[1];
  if (section === "documents") return "documents";
  if (section === "office") return "office";
  return "list";
};

export const getExpenseSectionPermissionKey = (section, action = "read") => {
  const base = String(action || "read").trim();
  return section === "office" ? `office_${base}` : base;
};

export const canReadExpenseManagementTab = (user, tab) => {
  if (hasAdminAccess(user)) return true;
  return checkPermission(tab.permission, tab.permissionKey || "read");
};
